import { useEffect, useRef } from 'react';

// Use previous state
// https://usehooks.com/usePrevious/
export const usePrevious = <T = any>(value: T) => {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};
